module.exports = __webpack_public_path__ + "static/media/longTerm_popupImage.fa05b851.png";